import type { CurvaDialogProps } from "./types-curva-dialog";
import { useCurvaDialog } from "./use-curva-dialog";
import { CurvaDialogView } from "./view-curva-dialog";

export function CurvaDialog(props: CurvaDialogProps) {
  const vm = useCurvaDialog(props);

  return <CurvaDialogView {...vm} />;
}

export type * from "./types-curva-dialog";
